module.exports = __webpack_public_path__ + "img/xue.1d58c8e1.png";